import { useContext } from 'react';

import { AccordionContainer } from '@/components/AccordionContainer';
import { PriceHistorySection } from '@/components/PriceHistorySection';
import { DataContext } from '@/contexts/DataContext';
import useTranslation from '@/hooks/useTranslation';
import { getObjectEntries } from '@/utils/getObjectEntries';

export const PricesOptionsSection = () => {
  const t = useTranslation();
  const { data } = useContext(DataContext);
  const pricesHistory = data?.pricesHistory;
  return (
    <AccordionContainer keyName={'PRICES'} visibleTitle={t('options.section.PRICES')}>
      {pricesHistory &&
        getObjectEntries(pricesHistory).map(([priceCategory, priceHistory]) => {
          return (
            <PriceHistorySection
              key={`price-history-section-${priceCategory}`}
              title={priceCategory}
              data={priceHistory}
              unit={priceCategory}
            />
          );
        })}
    </AccordionContainer>
  );
};
